import React from 'react';
import cx from 'classnames';

function Description(props) {
    const descriptionClasses = cx({
        'title': true,
        'protherm': props.brand ===  'protherm',
        'vaillant': props.brand ===  'vaillant'
    });
    return (
        <div className={descriptionClasses}>
			<h1>Hodnotenie technika a servisného úkonu</h1>
			<h2>{props.model}</h2>
		</div>
    );
}

Description.propTypes = {
    model: React.PropTypes.string.isRequired,
    brand: React.PropTypes.string.isRequired,
};
Description.defaultProps = {};
Description.contextTypes = {};

export default Description;



/** WEBPACK FOOTER **
 ** ./src/components/Description.js
 **/